import { render, staticRenderFns } from "./CodeView.vue?vue&type=template&id=dc6b2ed6&"
import script from "./CodeView.vue?vue&type=script&lang=ts&"
export * from "./CodeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports